import React from "react";
import { Alert, Card } from "react-bootstrap";

interface ErrorItem {
  row: number;
  message: string;
}

interface ErrorCategory {
  [key: string]: ErrorItem[];
}

interface ErrorListProps {
  errors: ErrorCategory;
}

const ErrorList: React.FC<ErrorListProps> = ({ errors }) => {
  if (!errors || typeof errors !== "object" || Object.keys(errors).length === 0) {
    return <p className="text-muted">No errors to display.</p>;
  }

  return (
    <div className="mt-3">
      {Object.entries(errors).map(([category, errorItems]) => {
        const errorList = Array.isArray(errorItems) ? errorItems : [];

        return (
          <Card key={category} className="mb-3 border-danger">
            <Card.Header className="bg-danger text-white">
              <strong>{category} Errors</strong>
            </Card.Header>
            <Card.Body>
              {errorList.length > 0 ? (
                errorList.map((err, index) => (
                  <Alert key={index} variant="danger" className="mb-2">
                    <strong>[Row {err.row}]</strong>: {err.message}
                  </Alert>
                ))
              ) : (
                <p className="text-muted">No errors found in this category.</p>
              )}
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
};

export default ErrorList;
